import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canCreateBroker } from "./permissions";
import { useRoles } from "./useRoles";

type Props = {
  children: ReactNode;
};

export const RequireCreateBroker = ({ children }: Props) => {
  const roles = useRoles();

  if (!canCreateBroker(roles)) {
    return <Navigate to="/brokers" replace />;
  }

  return children;
};
